import qc from 'qc'
import { scripts } from '@ps/bridge/qc/scripts/index'
export type MapVideoNodeUUIDType = {
  [key: string]: string;
}
export interface VideosManagerScript {
  /** 场景ID对应当前场景所有节点 */
  mapVideoNodes: {
    [key: string]: MapVideoNodeUUIDType;
  };
  /** 场景最大视频节点数量 */
  maxNodesCnt: number;
  /**
   * 添加视频节点
   * @param sceneUUID 场景节点UUID
   * @param videoUUID 视频节点UUID
   */
  addVideoNode(sceneUUID: string, videoUUID: string): Map<string, Map<string, qc.Node>>;
  /**
   * 删除场景中对应的视频节点
   * @param sceneUUID 场景节点UUID
   * @param videoUUID 视频节点UUID
   * @returns 如果 Map 对象中存在该元素，则移除它并返回 true；否则如果该元素不存在则返回 false。
   */
  deleteVideoNode(sceneUUID: string, videoUUID: string): boolean;
  /**
   * 删除场景中所有的视频节点
   * @param sceneUUID 场景节点UUID
   * @returns 如果 Map 对象中存在该元素，则移除它并返回 true；否则如果该元素不存在则返回 false。
   */
  deleteAllVideoNode(sceneUUID: string): boolean;
}

/**
 * ps.Video 脚本在编辑与线上运行的时候都会加载进去
 * @param node
 * @param addScriptIfScriptNotExist
 */
export const getScript = (node: qc.Node, addScriptIfScriptNotExist = true): VideosManagerScript | undefined => {
  const config: VideosManagerScript | undefined = node.getScript(scripts.videosManager.name)
  if (config) {
    return config
  }
  if (addScriptIfScriptNotExist) {
    return node.addScript(scripts.videosManager.name) as VideosManagerScript
  }
  return config
}
